// i18n area 'vms' — locale cs-CZ (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.cs-CZ.meta.json.
import type { enUS } from './vms'

export const csCZ: typeof enUS = {
  vms: {
    spof: {
      title: 'Nezávislost na uzlu',
      single: 'Jediný bod selhání',
      alternativesNow: 'Alternativy nyní',
      structural: 'Z konstrukce',
      binding: 'Omezující podmínka',
      movableNow: 'Migrace možná nyní',
    },
    title: 'Virtuální stroje',
    migratingChip: 'Probíhá migrace',
    templateChip: 'Šablona',
    expendableTooltip: 'V degradovaném klastru patří mezi první, které padnou, a po ztrátě uzlu se nemusí znovu spustit.',
    expendableHaTooltip: 'Dokud je klastr zdravý, je vždy restartována; v degradovaném klastru mají přednost chráněné VM — může být zastavena nebo zůstat vypnutá, dokud není klastr zase celý, pak se sama vrátí.',
    viewDetails: 'Zobrazit podrobnosti',
    profileLegacy: 'Jiný OS',
    hugePagesNone: 'Žádné — běžná paměť',
    hugePages2M: 'Stránky 2 MiB',
    hugePages1G: 'Stránky 1 GiB',
    searchPlaceholder: 'Hledat podle názvu',
    name: 'Název',

    // Jednotná terminologie (#94a): phase se všude jmenuje 'Fáze' — starý
    // klíč 'state' zanikl s vyleštěním seznamu.
    vcpus: 'vCPU',
    memory: 'Paměť',
    ipAddresses: 'IP adresy',
    noIp: 'Žádná IP',
    authorityNode: 'Authority',
    authorityNextStart: 'přiřazena při příštím spuštění',
    scope: 'Scope',
    empty: 'Žádné virtuální stroje',
    loadError: 'Virtuální stroje se nepodařilo načíst — je backend TVirt dostupný?',
    filterOverlay: 'overlay síť',
    filterDisk: 'disk',
    filterImage: 'obraz',
    filteredBy: 'Filtrováno podle {kind}',
    filterPhase: 'Fáze',
    filterProtection: 'Ochrana',
    filterAll: 'Vše',
    filterScopePlaceholder: 'Filtrovat podle scope',
    filtersToggle: 'Filtry',
    scopeTree: {
      title: 'Scope',
      all: 'Celý klastr',
      noChildren: 'Zde nejsou žádné pod-scope',
      recursive: 'Zahrnout potomky',
      collapse: 'Sbalit panel scope',
      up: 'O úroveň výš',
      countTooltip: '{direct} VM v tomto scope · {total} včetně potomků'
    },

    // Dvoukrokový výběr ISO (#85): nejdřív katalog, pak jeho ISO.
    isoPicker: {
      catalog: 'Katalog',
      unknownCatalog: 'Mimo viditelné katalogy',
      noIsos: 'Žádné připravené obrazy ISO v tomto katalogu'
    },
    actionsHeader: 'Akce',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Hardware',
      tags: 'Tagy',
      age: 'Stáří',
      disk: 'disk',
      disks: 'disky',
      empty: 'Žádné šablony — označte vypnutou VM jako šablonu, nebo naklonujte VM jako šablonu.',
      clone: 'Klonovat / nasadit',
      editTags: 'Upravit tagy',

      // Round K3 (#64): export šablony jako souboru .tvtpl katalogu.
      exportAction: 'Exportovat do katalogu (.tvtpl)',
      exportTitle: 'Exportovat do katalogu',
      exportSubmit: 'Exportovat',
      exportError: 'Export se nezdařil',
      exportHint: 'Šablona se zabalí do archivu .tvtpl (hardwarový manifest + každý disk zploštělý do qcow2) jako nový soubor Template VM ve zvoleném katalogu. NIC, média CD/DVD a cloud-init necestují — spec formátu uvádí každé záměrné vynechání.',
      exportName: 'Název souboru',
      exportNameHint: 'Prázdné = <template>-export-<n>',
      exportStorageDefault: 'Úložiště metadat šablony',

      // Import z katalogu (Luca 2026-08-03): položka toolbaru karty Šablony —
      // backend K3/K4 pokrývá všechny formáty vm-template, volbou je
      // SOUBOR (formát cestuje jen pro čtení).
      importAction: 'Importovat z katalogu',
      importTitle: 'Importovat z katalogu',
      importHint: 'Soubor Template VM ve stavu ready ze zvoleného katalogu se stane šablonou inventáře: formát souboru (tvtpl, ova, ovf nebo holé qcow2) sám rozhodne, jak se importuje — vy vybíráte jen soubor.',
      importFile: 'Soubor katalogu',
      importFileHint: 'Importují se jen soubory ready — soubor uprostřed uploadu importovat nelze',
      importNoFiles: 'Žádné soubory Template VM ready v tomto katalogu — nejdřív nějaký nahrajte nebo exportujte'
    },
    templateDetail: {
      quickDeploy: 'Kompatibilita s QuickDeploy',
      quickDeployNone: 'Nedeklarována',
      quickDeployHint: 'Deklarujte ji jen tehdy, pokud golden image obsahuje cloud-init (Linux) nebo cloudbase-init po sysprep /generalize (Windows): platforma deklaraci důvěřuje a nikdy se nedívá dovnitř hosta.',
      notFound: 'Šablona nenalezena',
      frozen: 'Hardwarová konfigurace je zmrazená: pro její úpravu převeďte šablonu zpět na VM. Název, poznámky a tagy zůstávají upravitelné.',
      storage: 'Úložiště',
      size: 'Velikost',
      configTitle: 'Konfigurace (zmrazená)',
      usbClasses: 'Požadované třídy USB',
      gpuClasses: 'Požadované třídy GPU'
    },
    sharedDisksTab: {
      title: 'Sdílené disky',
      sharing: 'Sdílení',
      sharingNone: 'Jedno připojení',
      sharingMultiwriter: 'Sdílený zápis (multiwriter)',
      sharingReadonly: 'Sdílené jen pro čtení',
      usedBy: 'Používá',
      attachedTo: 'Připojen k',
      notAttached: 'Připojen k žádné VM',
      changeSharing: 'Změnit režim sdílení',
      changeSharingTitle: 'Režim sdílení',
      changeSharingLocked: 'Režim lze změnit jen dokud disk nepoužívá žádná VM',
      sharingChanged: 'Režim sdílení aktualizován.',
      lun: 'Celý LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Sériové číslo',
      antiAffinityWarning: 'Dva nebo více členů běží na stejném uzlu bez pravidla anti-afinity: výpadek jednoho uzlu je shodí všechny',
      antiAffinityCreate: 'Vytvořit pravidlo',
      createSourceLun: 'Převzít celý LUN targetu',
      createLunNumber: 'Číslo LUN (id namespace u NVMe)',
      createLunHint: 'Nic se nealokuje: velikost se při převzetí přečte ze zařízení',
      noPr: 'V tomto vydání nejsou SCSI-3 persistent reservations: Windows Failover Cluster s klasickým sdíleným diskem není validován; clustery koordinující se po síti (GFS2/OCFS2, RHEL HA, shared-disk databáze) ano'
    },
    unusedDisksTab: {
      title: 'Nepoužité disky',
      attach: 'Připojit k VM',
      attachTitle: 'Připojit k VM',
      vm: 'Virtuální stroj',
      noVms: 'Žádná dostupná VM',
      noSlots: 'Na této VM není žádný volný slot',

      // Vytvoření samostatného disku (#87): návrat z penzionovaného Inventáře,
      // teď s EXPLICITNÍM polem scope (není VM, od které by dědil).
      create: 'Vytvořit disk',
      createTitle: 'Vytvořit disk',
      createSourceBlank: 'Prázdný disk',
      createSourceImage: 'Z obrazu v katalogu',
      createImage: 'Obraz',
      createImageEmpty: 'Ve viditelných katalozích není žádný připravený obraz šablony VM',
      createSizeFromImageHint: 'Předvyplněno virtuální velikostí obrazu — může pouze růst',

      // #107 (DESTRUKTIVNÍ, ratifikováno): qcow2 → soubor katalogu vm-template
      // na stejném úložišti, nula zkopírovaných bajtů — disk přestává existovat.
      convert: 'Převést na šablonu VM…',
      convertOnlyQcow2: 'Převést lze jen disky qcow2 — raw není registrovatelný formát šablony',
      convertTitle: 'Převést na šablonu VM',
      convertSubmit: 'Převést (zničí disk)',
      convertError: 'Konverzi se nepodařilo spustit',
      convertWarning: 'DESTRUKTIVNÍ: disk se stane souborem šablony VM ve zvoleném katalogu — stejné úložiště, nula zkopírovaných bajtů — a PŘESTÁVÁ EXISTOVAT jako disk. Cesta zpět nevede, leda vytvořit ze šablony nový disk.',
      convertNameHint: 'Název souboru katalogu — výchozí je název disku',
      convertConfirm: 'Rozumím: disk bude zničen',
      convertStarted: 'Konverze zahájena — šablona se v katalogu objeví po dokončení úlohy.',
      storageLockHint: 'Úložiště se mění jen akcí Přesunout',
      source: 'Původ',
      sourceClone: 'Klon jiného disku',
      sourceCloneLinked: 'Linked clone jiného disku',
      sourceImage: 'Vytvořen z obrazu',
      sourceBlank: 'Vytvořen prázdný',
      allocated: 'Alokováno / virtuální velikost',
      observedAt: 'Pozorováno',
      snapshots: 'Snímky',
      snapshotsEmpty: 'Žádné snímky'
    },
    phase: {
      defined: 'Nikdy nezapnutá',
      starting: 'Spouští se',
      running: 'Běží',
      stopping: 'Zastavuje se',
      stopped: 'Vypnutá',
      paused: 'Pozastavená',
      failed: 'Selhala',
      deleting: 'Odstraňuje se'
    },
    stopCause: {
      'api': 'Zastavena platformou TVirt (akce nebo API)',
      'guest-shutdown': 'Vypnutí zahájené operačním systémem hosta',
      'crash': 'Pád hosta',
      'qemu-exit': 'Proces QEMU skončil neočekávaně',
      'host-reboot': 'Uzel byl restartován',
      'migrated': 'Migrována na jiný uzel',
      'fenced': 'Ukončena fencingem HA (uzel se vrátil)'
    },
    detail: {
      notFound: 'Virtuální stroj nenalezen',
      details: 'Podrobnosti',
      id: 'ID',
      scope: 'Scope',
      profile: 'Hardwarový profil',
      firmware: 'Firmware',
      firmwareFile: 'Verze firmwaru UEFI',
      firmwareUpdate: 'K dispozici aktualizace',
      firmwareUpdateHint: 'Platforma dodává novější firmware UEFI. Aktualizace není nikdy automatická: aplikuje se při vypnuté VM, když o tom rozhodnete vy.',
      arch: 'Architektura',
      node: 'Uzel',
      bootOrder: 'Pořadí spouštění',
      agent: 'Stav agenta',
      agentConnected: 'Připojen',
      agentNotConnected: 'Nepřipojen',
      protected: 'Chráněná',
      linkedClones: 'Propojené klony',
      restartPolicy: 'Politika restartu',
      preferredNode: 'Preferovaný uzel',
      noPreference: 'Bez preference (automatický placement)',
      preferNodes: 'Preferované tagy uzlů',
      requireNodes: 'Povinné tagy uzlů',
      noPlacementTags: 'Žádné',
      placementTag: 'Tag',
      placementValue: 'Hodnota',
      placementAddTag: 'Přidat tag',
      proximityHa: 'HA TVirt Proximity',
      proximityHaRestarts: 'restartů HA',
      proximityHaGaveUp: 'crash loop — HA to vzdalo',
      failoverProtection: 'Ochrana při degradaci',
      protectionProtected: 'Chráněná',
      protectionExpendable: 'Postradatelná při degradaci',
      protectionInherit: 'Dědí',
      lastStop: 'Poslední zastavení',
      yes: 'Ano',
      no: 'Ne',
      tabOverview: 'Přehled',
      tabSnapshots: 'Snímky',
      tabBackups: 'Zálohy',
      hardware: 'Hardware',
      name: 'Název',
      hwSystem: 'Systém',
      hwCpu: 'CPU',
      hwMemory: 'Paměť',
      hwBoot: 'Spouštění',
      hwIdentity: 'Identita',
      hwCluster: 'Klastr a agent',
      cpuTopology: 'Topologie CPU',
      cpuModel: 'Model CPU',
      cpuLimit: 'Limit CPU',
      cpuWeight: 'Váha CPU',
      cpuNested: "Vnořená virtualizace",
      cpuNestedHint: "Zpřístupní hostu vmx/svm (pouze s modelem CPU host). U běžícího VM se změna projeví při příštím power cycle (PendingRestart); umístění připouští jen uzly se zapnutým nested.",
      unlimited: 'Neomezeno',
      memory: 'Paměť',
      balloon: 'Balloon',
      hugePages: 'Obrovské stránky',
      hugePagesTradeoff: 'Méně práce s překladem adres a paměť, která nikdy neskončí na disku; výměnou zůstává rezervace zamčená na uzlu, dokud je VM zapnutá, paměť se už nededuplikuje a spuštění selže, pokud uzel nemá dost volných stránek.',
      disks: 'Disky',
      cdroms: 'Mechaniky CD/DVD',
      nics: 'Síťová rozhraní',
      slot: 'Slot',
      disk: 'Disk',
      encrypted: 'Šifrovaný',
      image: 'Obraz',
      emptyDrive: 'Prázdná mechanika',
      emptyOption: '(prázdné)',
      network: 'Síť',
      mac: 'MAC',
      connected: 'Připojeno',
      unplugged: 'Odpojeno',
      noDevices: 'Žádné',
      screenshot: 'Snímek obrazovky',
      capturedAt: 'Pořízen v',
      noCapture: 'Zatím žádný snímek',
      snapshotName: 'Název',
      snapshotCreated: 'Vytvořen',
      snapshotMemory: 'Včetně paměti',
      noSnapshots: 'Žádné snímky',
      pendingRestart: 'Čekající změny: aplikují se při příštím power cycle.',
      applied: 'aplikováno',
      appliedHint: 'Běžící VM se spustila s touto hodnotou — nakonfigurovaná hodnota se aplikuje při příštím power cycle.',
      actionError: 'Akce se nezdařila',
      actionStillRunning: 'Akce stále běží: výsledek zatím není znám',
      tabConsole: 'Konzole',
      consoleConnect: 'Připojit',
      consoleDisconnect: 'Odpojit',
      consoleConnecting: 'Připojování…',
      consoleReconnecting: 'Připojování…',
      consoleUnavailable: 'Konzole je dostupná, když VM běží nebo je pozastavená.',
      consoleError: 'Připojení ke konzoli se nezdařilo',
      consoleTaken: 'Relaci konzole převzal {user}',
      consoleReconnect: 'Znovu připojit',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Podržte {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Otevřít na celou obrazovku v nové kartě',
      consoleLoadFailed: 'VM nenalezena nebo nedostatečná oprávnění',
      consoleClose: 'Zavřít',
      tabStats: 'Statistiky',
      tabTasks: 'Úlohy',
      tabLogs: 'Logy',
      statsCpu: 'CPU',
      statsMemory: 'Paměť',
      statsDisk: 'I/O disku',
      statsRange: 'Interval',
      statsNoData: 'V intervalu nejsou žádná data — statistiky se vzorkují, když VM běží.',
      statsError: 'Statistiky se nepodařilo načíst',
      cpuUsage: 'Využití',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Využitá',
      memGuestAvailable: 'Dostupná (host)',
      schema: 'Schéma',
      consoleProtocol: 'Konzole',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Úložiště metadat',
      startupOnBoot: 'Spouštět při startu',
      startupOrder: 'Pořadí startu',
      startupDelay: 'Zpoždění startu',
      seconds: 's',
      enabled: 'Povoleno',
      disabled: 'Zakázáno'
    },
    actionsAvailable: 'Dostupné akce',
    actions: {
      start: 'Spustit',
      stop: 'Zastavit',
      pause: 'Pozastavit',
      resume: 'Pokračovat',
      reset: 'Resetovat',
      migrate: 'Migrovat',
      clone: 'Klonovat',
      moveStorage: 'Přesunout na úložiště…',
      moveScope: 'Přesunout do scope…',
      openConsole: 'Otevřít konzoli',
      forceStop: 'Vynutit vypnutí',
      markTemplate: 'Označit jako šablonu',
      unmarkTemplate: 'Převést zpět na VM',
      error: 'Akci se nepodařilo provést'
    },
    cordon: {
      confirmTitle: 'Uzel je v režimu údržby',
      confirmHint:
        'Kordon nelze snížit, dokud je úložiště clusteru nedostupné. Potvrzením prohlašujete, že to víte: VM se tam přesto zapne a souhlas zůstane zaznamenán v úloze.',
      confirm: 'Přesto zapnout'
    },
    markTemplate: {
      confirmTitle: 'Označit {name} jako šablonu?',
      confirmBody: 'Konfigurace se zmrazí a VM už nepůjde zapnout — jen klonovat, nebo převést zpět na VM. Název, poznámky a tagy zůstávají upravitelné.',
      confirm: 'Označit jako šablonu',
      moved: '{name} je teď šablona — přesunula se na kartu Šablony.'
    },
    unmarkTemplate: {
      confirmTitle: 'Převést {name} zpět na VM?',
      confirmBody: 'Šablona se znovu stane obyčejnou VM: upravitelnou a spustitelnou (příští spuštění ji umístí na uzel).',
      confirm: 'Převést zpět na VM',
      moved: '{name} je zase virtuální stroj — přesunula se na kartu Virtuální stroje.'
    },

    // Round #123: odkaz na uzel přes TAG (selektor #106) v dialozích spuštění
    // a migrace — včetně náhledu rozřešené množiny.
    nodeByTag: {
      label: 'Podle tagu uzlu',
      hint: 'tag=hodnota, oddělené čárkou (v AND): decider vybírá mezi odpovídajícími uzly',
      invalid: 'Neplatný formát — použijte tag=hodnota, oddělené čárkou',
      resolved: 'Odpovídající členové: {nodes}'
    },
    migrate: {
      title: 'Migrace za běhu',
      submit: 'Migrovat',
      target: 'Cílový uzel',
      auto: 'Automaticky (Proximity)',
      hint: 'VM se přesune bez power cycle. Každé úložiště, kterého se dotýká, musí být sdílené; pozastavená VM migruje pozastavená.',
      error: 'Migrace byla odmítnuta'
    },
    moveStorage: {
      title: 'Přesunout na úložiště',
      submit: 'Přesunout',
      target: 'Cílové úložiště',
      noTargets: 'Žádné úložiště nepřijímá disky',
      hint: 'Všechny disky vypnuté VM putují na zvolené úložiště, jeden po druhém, se zachováním svého id — disky už v cíli se přeskakují. Průběh žije na stránce úloh.',
      error: 'Přesun byl odmítnut'
    },
    moveScope: {
      title: 'Přesunout do scope',
      submit: 'Přesunout',
      target: 'Cílový scope',
      hint: 'VM změní scope okamžitě — id a disky zůstávají, její owned disky ji následují a může zůstat zapnutá. Dnes žije v {scope}. Kdo ji vidí, se mění se scope.',
      error: 'Přesun do jiného scope byl odmítnut'
    },
    start: {
      title: 'Spustit VM',
      submit: 'Spustit',
      target: 'Cílový uzel',
      auto: 'Automaticky (doporučeno)',
      recommended: 'doporučeno',
      hint: 'Vyberte cílový uzel, nebo nechte Proximity rozhodnout mezi platnými kandidáty. Uzly, které ji nemohou hostit, jsou zakázané s uvedením důvodu.',
      error: 'VM se nepodařilo spustit'
    },
    console: {
      media: 'Mechaniky CD/DVD',
      mediaGuestToolsHint: 'Obsahuje TVirt Guest Tools — odsud je můžete vysunout nebo odebrat mechaniku',
      slotOpsDeferred: 'Na tomto profilu se přidání a odebrání mechanik aplikuje při příštím power cycle (změny média jsou okamžité).',
      mountGuestTools: 'Připojit TVirt Guest Tools',
      ejectGuestTools: 'Vysunout TVirt Guest Tools',
      bootOrder: 'Pořadí spouštění',
      bootOrderHint: 'Nové pořadí se uloží hned a aplikuje se při příštím power cycle — relace konzole zůstává připojená.'
    },
    snapshots: {
      create: 'Vytvořit snímek',
      createTitle: 'Vytvořit snímek',
      createSubmit: 'Vytvořit',
      name: 'Název',
      nameHint: 'Písmena, číslice, tečka, pomlčka, podtržítko.',
      consistencyHint: 'Konzistence je automatická: guest agent zmrazí filesystemy, když odpovídá; jinak se VM kolem snímku na okamžik pozastaví.',
      memory: 'Zahrnout paměť',
      memoryHint: 'Zachytí živou RAM: obnovení vrátí VM běžící. Vyžaduje všechny disky qcow2.',
      currentChip: 'Jste zde',
      revert: 'Obnovit',
      revertTitle: 'Obnovit {name}?',
      revertBody: 'Disky se vrátí do stavu snímku; vše, co se stalo potom, je ztraceno. Snímek jen disků vyžaduje zastavenou VM.',
      delete: 'Odstranit',
      deleteTitle: 'Odstranit snímek {name}?',
      deleteBody: 'Bod obnovení zmizí; obsah disků zůstává nedotčen.',
      deleteMergeHint: 'Jeho delta se sloučí do {children}: každý pozdější bod obnovení zůstává platný.',
      deleteDuplication: 'Přijímám duplikaci',
      deleteDuplicationHint: 'Delta se zkopíruje do každého z {count} čtenářů (potomci snapshotu a, pokud je tento aktuální, aktivní hlava): obsazené místo může růst místo klesat.',
      error: 'Operace se snímkem byla odmítnuta'
    },
    clone: {
      title: 'Klonovat VM',
      submit: 'Klonovat',
      name: 'Název kopie',
      storage: 'Cílové úložiště disků',
      sameStorage: 'Stejné jako zdroj',
      full: 'Úplná kopie',
      fullHint: 'Zkopíruje každý bajt a přetne vazbu se zdrojovými disky. Výchozí je linked clone: okamžitý, ale připoutaný ke zdroji (jen qcow2).',
      hint: 'Klon si zachová konfiguraci a firmware zdroje; MAC adresy a identita TPM jsou nové.',
      markAs: 'Druh klonu',
      markAsInheritVm: 'Jako zdroj (VM)',
      markAsInheritTemplate: 'Jako zdroj (šablona)',
      markAsVm: 'Virtuální stroj',
      markAsTemplate: 'Šablona',
      markAsHintVm: 'Zvolte Šablona a povýšíte kopii jedním krokem.',
      markAsHintTemplate: 'Zvolte Virtuální stroj a nasadíte z této šablony jedním krokem.',
      error: 'Klonování bylo odmítnuto'
    },
    bulk: {
      selected: 'vybráno',
      deleteTitle: {
        one: 'Odstranit {count} vybranou VM?',
        few: 'Odstranit {count} vybrané VM?',
        many: 'Odstranit {count} vybrané VM?',
        other: 'Odstranit {count} vybraných VM?'
      },
      deleteBody: 'Každá VM prochází stejnými pojistkami jako samostatné odstranění; odmítnutí se hlásí po položkách.',
      done: 'přijato',
      refused: 'odmítnuto'
    },
    delete: {
      button: 'Odstranit',
      confirmTitle: 'Odstranit {name}?',
      confirmBody: 'Virtuální stroj a disky v jeho vlastnictví budou odstraněny. Operaci nelze vrátit zpět.',
      keepDisks: 'Ponechat disky',
      keepDisksHint: 'Disky vytvořené s VM zůstanou ve svém úložišti jako samostatné disky.',
      confirm: 'Odstranit',
      cancel: 'Zrušit',
      error: 'Odstranění se nezdařilo',
      blockedPhase: 'Nejdřív VM zastavte',
      blockedProtected: 'VM je chráněná — nejdřív odeberte ochranu',
      blockedDeleting: 'Odstranění už probíhá'
    },
    logs: {
      title: 'Logy',
      subtitle: 'Strukturované log framy z úloh, které se dotýkají této VM',
      when: 'Kdy',
      task: 'Úloha',
      level: 'Úroveň',
      message: 'Zpráva',
      empty: 'Zatím žádné logy',
      loadError: 'Logy se nepodařilo načíst — je backend TVirt dostupný?'
    },
    stop: {
      title: 'Zastavit virtuální stroj',
      modeGraceful: 'Graceful vypnutí',
      modeGracefulHint: 'Operační systém hosta je požádán, aby se vypnul přirozenou cestou (ACPI); pokud žádost ignoruje, po timeoutu následuje vynucené vypnutí.',
      modeForced: 'Vynucené vypnutí',
      modeForcedHint: 'Okamžitě odpojí napájení, jako vytažení zástrčky.',
      timeout: 'Fallback timeout (sekundy)',
      timeoutHint: 'Jak dlouho čekat na hosta, než se vypnutí vynutí'
    },

    // Menu split tlačítka vytvoření (Luca 2026-07-23): „Od nuly" otevírá
    // průvodce, další dvě položky jsou stuby z roadmapy.
    createFromScratch: 'Od nuly',
    createFromTemplate: 'Ze šablony',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Spustit deploy',
      error: 'Deploy se nezdařil',
      compatNote: 'QuickDeploy vyžaduje šablonu kompatibilní s QuickDeploy: platforma při prvním spuštění přizpůsobí hosta (síť, doména, aktivace).',
      template: 'Šablona',
      noTemplates: 'Žádná šablona zatím nedeklaruje kompatibilitu s QuickDeploy — deklarujte ji v záložce Šablony (Linux s cloud-init, Windows s cloudbase-init po sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Název hostitele',
      hostnameHint: 'Název hostitele nebo FQDN; prázdné = název VM (Windows: nejvýše 15 znaků)',
      ip: 'IP adresa',
      ipHint: 'Host a prefix, např. 192.168.122.101/24; prázdné = DHCP',
      gateway: 'Brána',
      dns: 'DNS servery',
      dnsHint: 'Nejvýše tři, oddělené čárkou',
      count: 'Instance',
      countHint: 'Více než jedna: pojmenované <název>-1…-N, pouze DHCP',
      user: 'Uživatel',
      userHint: 'Prázdné = výchozí uživatel image (Linux) nebo Administrator (Windows)',
      password: 'Heslo',
      passwordHint: 'Zapíše se do vygenerované user-data, kterou platforma poté deklaruje jako tajnou: nikdo ji už nepřečte',
      sshKeys: 'Veřejné klíče SSH',
      sshKeysHint: 'Jeden na řádek (ssh-ed25519 AAAA… komentář)',
      productKey: 'Product key Windows',
      kmsServer: 'Server KMS',
      kmsHint: 'Host nebo host:port — vyžaduje product key (klientský klíč KMS)',
      adDomain: 'Připojit k doméně Active Directory',
      adDomainHint: 'Prázdné = bez připojení k doméně',
      adUser: 'Účet pro připojení',
      adPassword: 'Heslo účtu pro připojení',
      adOu: 'Cílová OU (volitelné)',
      advanced: 'Pokročilé: surové dokumenty',
      userData: 'user-data (surová)',
      userDataHint: 'Nahrazuje vygenerovanou user-data: uživatel, heslo, klíče a pole Windows výše musí zůstat prázdné',
      networkConfig: 'network-config (surová)',
      networkConfigHint: 'Nahrazuje vygenerovanou síť: IP, brána a DNS výše musí zůstat prázdné',
      secret: 'Považovat surovou user-data za tajnou',
      secretHint: 'Označena jako tajná, přestane být API vracena komukoli a v Checkpointu cestuje zapečetěná masterpass',
      startNow: 'Spustit ihned',
      startNowHint: 'Každá instance se spustí hned po definování; seed vzniká při tomto spuštění'
    },

    create: {
      nicAttachmentNetwork: 'Logická síť (fabric)',
      nicNetwork: 'Logická síť',
      nicNetworkHint: 'DOPORUČENÁ cesta (F3): vNIC se realizuje na ODVOZENÉM bridgi obsluhujícího uzlu — bridge se rodí při explicitním apply fabric a start na uzlu, který ho ještě nenese, odmítne mluvě. Když odejde poslední reference flotily, bridge při příštím apply vypadne.',
      button: 'Vytvořit VM',
      title: 'Vytvořit virtuální stroj',
      dialogTitle: 'Vytvořit virtuální stroj',
      stepGeneral: 'Obecné',
      stepGeneralHint: 'Název a profil',
      stepCompute: 'CPU a RAM',
      stepComputeHint: 'Topologie a dimenzování',
      stepDisks: 'Disky',
      stepDisksHint: 'Vytvořit nebo připojit',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Mechaniky a média',
      stepNetwork: 'Síť',
      stepNetworkHint: 'NIC: trunk nebo bridge',
      stepSummary: 'Souhrn',
      stepSummaryHint: 'Zkontrolovat a vytvořit',
      name: 'Název',
      nameHint: 'Malá písmena, číslice a pomlčky (DNS-1123)',
      nextButton: 'Další',
      prevButton: 'Zpět',
      submitButton: 'Vytvořit',
      creating: 'Vytváření…',
      sockets: 'Sockety',
      cores: 'Jádra na socket',
      threads: 'Vlákna na jádro',
      totalVcpus: 'Celkem vCPU',
      memoryGib: 'Paměť (GiB)',
      cpuModelHint: "'host' vystaví CPU hostitele",
      cpuLimitHint: 'Strop v jádrech hostitele — prázdné = neomezeno',
      cpuNestedHint: "Zpřístupní hostu vmx/svm, aby mohl provozovat vlastní hypervizor — vyžaduje model CPU host a uzel se zapnutým nested",
      newDisk: 'Nový disk',
      attachDisk: 'Připojit existující disk',
      diskStorage: 'Úložiště',
      diskSize: 'Velikost (GiB)',
      diskSelect: 'Disk',
      addDisk: 'Přidat disk',
      addCdrom: 'Přidat mechaniku CD/DVD',
      addNic: 'Přidat síťové rozhraní',
      remove: 'Odebrat',
      slotLimit: 'Dosažen limit slotů',
      cdromImage: 'Obraz (prázdná mechanika, pokud chybí)',
      nicAttachment: 'Připojení',
      nicAttachmentTrunk: 'Overlay trunk',
      nicAttachmentBridge: 'Bridge hostitele',
      nicUntagged: 'Untagged overlay',
      nicUntaggedNone: 'Žádná (jen tagged)',
      nicTrunkHint: 'Aspoň jedna strana: untagged overlay a/nebo mapování tagged VLAN — VM může běžet jen na hostitelích deklarovaných každou odkazovanou overlay sítí',
      nicTaggedVlan: 'VLAN ID',
      nicTaggedOverlay: 'Overlay síť',
      addTagged: 'Přidat tagged VLAN',
      nicBridge: 'Název bridge hostitele',
      nicBridgeHint: 'Bridge NM podle názvu — VM může běžet jen na serverech, jejichž host network tento bridge deklaruje',
      nicMac: 'MAC (auto, pokud prázdné)',
      noDisksHint: 'Žádný disk: VM bude mít jen mechaniky CD/DVD, které přidáte.',
      noCdromsHint: 'Žádná mechanika CD/DVD: přidejte jednu, aby šlo spustit z obrazu ISO.',
      mountGuestTools: 'Připojit TVirt Guest Tools při prvním spuštění',
      mountGuestToolsHint: 'Vloží ISO s ovladači virtio a guest agentem do prázdné mechaniky CD (přidané, je-li třeba) — instalátor Windows je potřebuje, aby viděl své disky.',
      noNicsHint: 'Žádné síťové rozhraní: VM se spustí bez konektivity.',
      taggedMappings: 'Mapování tagged VLAN',
      summaryDevices: 'Zařízení',
      bootOrderTitle: 'Pořadí spouštění',
      bootOrderHint: 'Přetažením změníte pořadí — vyhrává první spustitelné zařízení; NIC spouštějí PXE',
      bootOrderUp: 'Posunout nahoru',
      bootOrderDown: 'Posunout dolů',
      createError: 'Vytvoření se nezdařilo'
    },
    edit: {
      button: 'Upravit',
      title: 'Upravit virtuální stroj',
      cancel: 'Zrušit',
      save: 'Uložit',
      error: 'Úprava se nezdařila',
      modelStoppedOnly: 'Lze měnit jen při vypnuté VM',
      firmwareStoppedOnly: 'Firmware lze měnit jen při vypnuté VM — při příštím spuštění stroj naběhne s novým firmwarem a proměnné UEFI zůstanou',
      hugePagesStoppedOnly: 'Lze měnit jen při vypnuté VM — při příštím spuštění se paměť postaví na novém backingu',
      runningHint: 'Změny se aplikují při příštím power cycle',
      sectionCpu: 'CPU',
      sectionMemory: 'Paměť',
      sectionPolicy: 'Zásady'
    },
    devices: {
      networkChip: 'síť fabric',
      title: 'Zařízení',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Přidat zařízení USB',
      addUsbTitle: 'Vyžádat třídu zařízení USB',
      usbClassHint:
        'VM žádá o TŘÍDU zařízení USB (hodnotu tagu usb-device), nikdy o konkrétní kus: při startu se na zvoleném uzlu vybere a zabere konkrétní volné zařízení. Otagujte registrovaná zařízení v Klastr › Prostředky USB a PCIe.',
      usbTag: 'Tag (usb-device)',
      usbValue: 'Hodnota třídy',
      noUsbTags: 'Žádné tagy usb-device — vytvořte jeden a otagujte registrovaná zařízení v Klastr › Prostředky USB a PCIe.',
      noUsbValues: 'Tento tag zatím nemá deklarované hodnoty.',
      usbEmpty: 'Žádné požadavky USB — přidejte třídu, aby se zařízení při startu předalo do VM.',
      usbClassChip: 'třída',
      usbPortChip: 'port',
      usbUnclaimed: 'Žádné zabrané zařízení — vyřeší se při startu VM.',
      addGpu: 'Přidat GPU',
      addGpuTitle: 'Vyžádat třídu GPU',
      gpuClassHint:
        'VM žádá o TŘÍDU GPU (hodnotu tagu gpu-device), nikdy o konkrétní kartu: při startu se na zvoleném uzlu vybere a zabere konkrétní volná karta a SPOLU s ní projde celá její skupina IOMMU. Otagujte registrované GPU v Klastr › Prostředky USB a PCIe.',
      gpuTag: 'Tag (gpu-device)',
      gpuValue: 'Hodnota třídy',
      noGpuTags: 'Žádné tagy gpu-device — vytvořte jeden a otagujte registrované GPU v Klastr › Prostředky USB a PCIe.',
      noGpuValues: 'Tento tag zatím nemá deklarované hodnoty.',
      gpuEmpty: 'Žádné požadavky GPU — přidejte třídu, aby se karta při startu předala do VM.',
      gpuClassChip: 'třída',
      gpuGroupChip: 'skupina IOMMU ×',
      gpuUnclaimed: 'Žádná zabraná karta — vyřeší se při startu VM.',
      gpuPowerCycle: 'Žádný hotplug GPU — změny platí od příštího power cycle (PendingRestart)',
      actions: 'Akce',
      attachDisk: 'Přidat disk',
      attachDiskTitle: 'Přidat disk',
      attach: 'Připojit',
      noFreeDisks: 'Žádný nepoužitý disk — vytvořte jej ve Virtuální stroje › Nepoužité disky.',
      addCdrom: 'Přidat mechaniku',
      addCdromTitle: 'Přidat mechaniku CD/DVD',
      editCdromTitle: 'Změnit obraz CD/DVD',
      changeMedia: 'Změnit obraz CD/DVD',
      ejectMedium: 'Vysunout',
      mountGuestTools: 'Připojit TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools připojeny',
      guestToolsClickMount: 'Vloží ISO TVirt Guest Tools do první prázdné mechaniky CD/DVD',
      guestToolsClickUnmount: 'Kliknutím vysunete — mechanika zůstane, prázdná',
      guestToolsNoSlot: 'Žádná prázdná mechanika CD/DVD — přidejte mechaniku (nebo vysuňte médium), abyste mohli TVirt Guest Tools připojit',
      guestToolsSkew: 'Připojena v{pinned}; uzel {node} nyní poskytuje v{current}: vysuňte a znovu připojte pro aktualizaci',
      ejectGuestTools: 'Vysunout TVirt Guest Tools (mechanika zůstane, prázdná)',
      guestToolsEjectConfirmTitle: 'Vysunout TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Médium se vysune ze zapnuté VM — mechanika CD/DVD zůstane, prázdná.',
      applyLive: 'Aplikovat hned (VM je zapnutá)',
      addNic: 'Přidat rozhraní',
      addNicTitle: 'Přidat síťové rozhraní',
      editNicTitle: 'Upravit síťové rozhraní',
      bridgeChip: 'bridge',
      cable: 'Virtuální kabel',
      plug: 'Zapojit virtuální kabel',
      unplug: 'Odpojit virtuální kabel',
      remove: 'Odebrat',
      removeTitle: 'Odebrat {device}?',
      removeBody: 'U zapnuté VM se změna aplikuje při příštím power cycle. Disky a obrazy se odpojují, nikdy neodstraňují.'
    }
  }
}
